import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MainNavComponent } from './main-nav/main-nav.component';
import { AppRoutingModule } from './app-routing.module';
import { SidebarModule } from './sidebar/sidebar.module';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { HttpModule } from '@angular/http';
import { HttpClient, HttpBackend, HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { ɵROUTER_PROVIDERS } from '@angular/router';
import { ToastrModule } from 'ng6-toastr-notifications';
import { DashboardModule } from './components/dashboard/dashboard.module';
import { AuthModule } from './components/auth/auth.module';
import { NgBootstrapFormValidationModule } from 'ng-bootstrap-form-validation';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { RequestInterceptor } from './shared/request-interceptor';
import { NgxUiLoaderModule } from 'ngx-ui-loader';
import { ThemeOptions } from './theme-options';
import { AutonumericModule } from '@angularfy/autonumeric';


// export class HttpClientTrans extends HttpClient {
//   constructor(handler: HttpBackend) {
//     super(handler);
//   }
// }

export function HttpLoaderFactory(httpClient: HttpClient) {
  return new TranslateHttpLoader(httpClient);
}

@NgModule({
  declarations: [
    AppComponent,
    MainNavComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    SidebarModule,
    HttpModule,
    HttpClientModule,
    TranslateModule.forRoot(
      {
        loader: {
          provide: TranslateLoader,
          useFactory: HttpLoaderFactory,
          deps: [HttpClient]
        }
      }
    ),
    ToastrModule.forRoot(),
    AutonumericModule.forRoot(),
    NgBootstrapFormValidationModule.forRoot(),
    NgxUiLoaderModule.forRoot(ThemeOptions.ngxUiLoaderConfig),
    NgbModule,
    DashboardModule,
    AuthModule
  ],
  providers: [
    ɵROUTER_PROVIDERS,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: RequestInterceptor,
      multi: true,
    },

  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
